import { apiUrlGet } from "../api_common";
import { axiosInstanceCreate } from "./axios_common";

const urlBase: string = apiUrlGet();

export const axiosNotes = axiosInstanceCreate(urlBase, {
  withCredentials: true,
});
